var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:_vm.status},[_c('icon',{attrs:{"name":_vm.icons[_vm.status]}}),_vm._v(" "+_vm._s(_vm.$t(_vm.labels[_vm.status]))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }